import { Controller } from "@hotwired/stimulus"

// The key ties a service to its delivery connector and to partners' and shops'
// settings, so saving a different key asks first (independent QA). The key is
// compared the way it is stored: trimmed, lowercase, without spaces.
export default class extends Controller {
  static targets = ["key"]
  static values = { original: String, message: String }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasKeyTarget) return

    const typed = this.keyTarget.value.trim().toLowerCase().replace(/\s+/g, "")
    if (typed && typed !== this.originalValue) {
      this.element.dataset.turboConfirm = this.messageValue.replace("__KEY__", typed)
    } else {
      delete this.element.dataset.turboConfirm
    }
  }
}
